/** Inställningar för hur omdömen visas publikt. Klientsäker fil. */

import { useQuery } from "@tanstack/react-query";

import { getTestimonialsDisplay } from "@/lib/settings.functions";

export type TestimonialsDisplay = {
  /** Hur många omdömen som visas på startsidan (1–12). */
  homeLimit: number;
  /** Om den publika omdömessidan (/omdomen, /en/reviews, /es/opiniones) är på. */
  publicPage: boolean;
};

export const DEFAULT_TESTIMONIALS_DISPLAY: TestimonialsDisplay = {
  homeLimit: 6,
  publicPage: true,
};

export function parseTestimonialsDisplay(value: unknown): TestimonialsDisplay {
  const raw = (value ?? {}) as { homeLimit?: unknown; publicPage?: unknown };
  const limit = Number(raw.homeLimit);
  return {
    homeLimit: Number.isFinite(limit) ? Math.min(12, Math.max(1, Math.round(limit))) : DEFAULT_TESTIMONIALS_DISPLAY.homeLimit,
    publicPage: raw.publicPage !== false,
  };
}

/**
 * Admin styr antal på startsidan och om omdömessidan är publik. Svaret cachas
 * i en dag i taget – när inställningen ändras slår det igenom vid nästa läsning.
 */
export function useTestimonialsDisplay(): TestimonialsDisplay {
  const { data } = useQuery({
    queryKey: ["testimonials", "display"],
    queryFn: () => getTestimonialsDisplay(),
    staleTime: 24 * 60 * 60 * 1000,
  });
  // Innan svaret finns vet vi inte om sidan är publik – då visas ingen länk.
  return { ...(data ?? DEFAULT_TESTIMONIALS_DISPLAY), publicPage: data?.publicPage === true };
}

/** True när den publika omdömessidan är avstängd – menylänkar ska då döljas. */
export function useReviewsPageEnabled(): boolean {
  return useTestimonialsDisplay().publicPage;
}
